import React from 'react';
import { Stack, Text, Icon, TooltipHost, DirectionalHint, ITheme } from 'office-ui-fabric-react';
import { MyContext } from '../../context';

interface AIDisclaimerProps {
    theme: ITheme;
    withBackground?: boolean;
}

interface AIDisclaimerState {
    isSmallScreen: boolean;
}

class AIDisclaimer extends React.Component<AIDisclaimerProps, AIDisclaimerState> {

    static contextType = MyContext

    constructor(props: AIDisclaimerProps) {
        super(props);
        this.state = {
            isSmallScreen: window.innerWidth <= 768,
        };
    }

    updateScreenSize = () => {
        this.setState({ isSmallScreen: window.innerWidth <= 768 });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateScreenSize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScreenSize);
    }

    render() {
        const { theme } = this.props;
        const { isSmallScreen } = this.state;

        const messageContent = (
            <>
                {this.context.getTranslation("compliance", "AIDisclaimer")}:{' '}
                <a
                    href="mailto:AI-Feedback@asc.de?subject=Feedback%20about%20AI-generated%20content"
                    style={{ color: theme.palette.themePrimary, textDecoration: 'underline' }}
                >
                    AI-Feedback@asc.de
                </a>
            </>
        );

        return (
            <Stack
                horizontal
                verticalAlign="center"
                styles={{
                    root: {
                        padding: 5,
                        width: '100%',
                        boxSizing: 'border-box',
                        backgroundColor: this.props.withBackground ? theme.palette.white : "transparent"
                    },
                }}
            >
                <Stack.Item
                    styles={{
                        root: {
                            color: theme.palette.themePrimary,
                            cursor: 'pointer',
                            flexShrink: 0,
                            marginRight: 10,
                            paddingTop: 2,
                        },
                    }}
                >

                    <TooltipHost
                        styles={{
                            root: {
                                cursor: !isSmallScreen ? 'default' : 'pointer'
                            },
                        }}
                        content={!isSmallScreen ? "" : messageContent}
                        directionalHint={DirectionalHint.topCenter}
                        calloutProps={{ gapSpace: 0 }}
                    >
                        <Icon iconName="Info" aria-label="Information" />
                    </TooltipHost>
                </Stack.Item>

                {!isSmallScreen && (
                    <Stack.Item styles={{ root: { color: theme.palette.neutralPrimary, fontWeight: 600 } }}>
                        <Text style={{ fontSize: "10px" }} >{messageContent}</Text>
                    </Stack.Item>
                )}
            </Stack>
        );
    }
}

export default AIDisclaimer;
